import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from 'redux-persist';
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from 'redux-persist/lib/storage';
import { rootReducer } from "../reducers/rootReducer";
import thunk from "redux-thunk";
import config from '../_helpers/config';

const composeEnhancers =
  (config.get('environment') !== "production" && typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['authAdmin', 'auth', 'language', 'partnerList'],
  stateReconcilier: autoMergeLevel2,
};


const pReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
  pReducer,
  composeEnhancers(
    applyMiddleware(thunk)
  )
);

const persistor = persistStore(store);
export { persistor, store };
